import { AuthService } from '../../services/auth.service';
import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';


export function checkUsernameExistsValidator(authService: AuthService) : AsyncValidatorFn {
  return (control: AbstractControl): Observable<ValidationErrors | null> => {
    const value = control.value;
    return authService.checkUsernameExists(value).pipe(
      map((usernameExistsInDB: string) => {
        return usernameExistsInDB ? { usernameExists: 'Sorry, This username is already taken.' } : null;
      }),
    );
  };
}
